import { createFileRoute } from "@tanstack/react-router";
import type {} from "@tanstack/react-start";
import { GonePage, goneHandler } from "@/lib/seo/gone";

// Retired: admin-added contact-profile pages (helpline cleanup).
export const Route = createFileRoute("/support/$")({
  server: { handlers: { GET: goneHandler } },
  component: GonePage,
});
